import { render, staticRenderFns } from "./drag-select.vue?vue&type=template&id=4b6c5336&"
import script from "./drag-select.vue?vue&type=script&lang=js&"
export * from "./drag-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6c5336')) {
      api.createRecord('4b6c5336', component.options)
    } else {
      api.reload('4b6c5336', component.options)
    }
    module.hot.accept("./drag-select.vue?vue&type=template&id=4b6c5336&", function () {
      api.rerender('4b6c5336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/drag-select.vue"
export default component.exports